/* eslint-disable no-console */
import React from 'react'
import { Button, Popconfirm } from 'antd'
import { useTranslation } from 'next-i18next'
import { ProjectDiscountPayload } from 'src/core/models'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { DeleteOutlined, EditTwoTone } from '@ant-design/icons'
import {
  projectFormStateSelector,
  setProjectFormItemValue,
  projectDetailsSelector,
  deleteProjectDiscount,
} from 'src/features'

const ProjectDiscountActionsColumn: React.FC<{ discount: ProjectDiscountPayload }> = ({ discount }) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const { discounts } = useAppSelector(projectFormStateSelector)
  const { project: projectToEdit } = useAppSelector(projectDetailsSelector)

  const handleEdit = () => {
    dispatch(setProjectFormItemValue({ key: 'currentDiscount', value: discount }))
  }

  const handleDelete = () => {
    let newList = discounts.filter(d => d.id !== discount.id)
    if (projectToEdit?.discounts?.some(d => d.id === discount.id)) {
      dispatch(deleteProjectDiscount(Number(discount.id)))
    }
    dispatch(setProjectFormItemValue({ key: 'discounts', value: newList }))
    dispatch(setProjectFormItemValue({ key: 'currentDiscount', value: null }))
  }

  return <>
    <Button
      type='ghost'
      size='middle'
      shape='circle'
      onClick={handleEdit}
      icon={<EditTwoTone />}
    />
      &nbsp; &nbsp;
    <Popconfirm
      title={t('general.SureDelete')}
      onConfirm={handleDelete}
      okText={t('general.Yes')}
      cancelText={t('general.Cancel')}
    >
      <Button
        danger
        size='middle'
        shape='circle'
        icon={<DeleteOutlined />}
      />
    </Popconfirm>
  </>
}

export default ProjectDiscountActionsColumn
